exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-set-details dt{float:left;width:160px;overflow:hidden;clear:left;text-align:left;text-overflow:ellipsis;white-space:nowrap}.index-set-details dd{margin-left:180px}.index-set-details dl{margin-bottom:0}", ""]);

// exports
